import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasskeyDeleteModalCmsKey = 'RemoveThisPasskey' | 'Caption' | 'Remove' | 'Cancel';

export const PasskeyDeleteModalCmsWithDefault: CmsObjectWithDefault<PasskeyDeleteModalCmsKey> = {
    RemoveThisPasskey: {
        cmsId: 553061,
        defaultTranslation: 'Remove this passkey?',
    },
    Caption: {
        cmsId: 553062,
        defaultTranslation:
            'You will no longer be able to use this passkey to sign in. You can create a new passkey for this device at any time.',
    },
    Remove: {
        cmsId: 553063,
        defaultTranslation: 'Remove',
    },
    Cancel: {
        cmsId: 155933,
        defaultTranslation: 'Cancel',
    },
};
